export default "__VITE_ASSET__CmawRSsB__"